import { Dialog } from 'primereact/dialog';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Toast } from 'reactstrap';
import ExhibitonTopbar from './ExhibitonTopbar';
import { Colors } from 'chart.js';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import Constants from '../../constants/Constants';
import utils from '../../constants/utils';
import FileService from '../../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';


export const FirstExhibitionPage = (props) => {
    console.log("FirstExhibitionPage", props);
    const { t } = useTranslation();
    const navigate = useNavigate();



    const chooseOptions = { icon: 'fas fa-cloud-arrow-up file-upload-icon p-button-header', iconOnly: true, padding: 0 };

    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [dates, setDates] = useState([props.startDate, props.endDate]);

    const onDateSelect = (event) => {
        console.log("dateSelect", event.value);

        if (event.value.length === 2) {
            let _ellapsedDay = utils.elapsedDay(event.value[0], event.value[1])
            if (_ellapsedDay > 90) {
                setDates([]);
                props?.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_exhibition_maxdate"), life: 5000 });

            } else {
                setDates(event.value);
                props.setStartDate(event.value[0]);
                props.setEndDate(event.value[1]);
            }

        }


    };

    const onSaveExhibiton = (status) => {
        console.log("onSaveExhibiton", status)
        props.onSaveExhibiton(status);
    }




    const RenderContent = () => {

        console.log("RenderContent props", props)

        return (



            <div className="flex flex-row align-items-top justify-content-between w-12" style={{ top: 0, bottom: 0, position: "absolute" }}>


                {props?.isEditable &&
                    <div className="flex flex-column justify-content-center  align-items-start w-6 h-12" >
                        <span className="block text-2xl w-12  mb-1  p-2 text-left pr-5">
                            <Button label={props.isExistExhibit ? t('global_btn_update') : t('global_btn_save')} icon="fa fa-save" className="p-button-rounded mr-2"
                                onClick={() => onSaveExhibiton(Constants.exhibitionStatus.DRAFT)}
                                disabled={props?.status && props?.status != 1}
                            ></Button>
                            <Button label={props.isExistExhibit ? t('global_btn_sendapprove') : t('global_btn_sendapprove')} icon="fa fa-save" className="p-button-rounded mr-2"
                                onClick={() => onSaveExhibiton(Constants.exhibitionStatus.IN_REVIEW)}
                                disabled={props?.status && props?.status != 1 || props?.status != 1}

                            ></Button>
                            <Button icon="fas fa-trash" className={"p-button-rounded  mr-2"}
                                onClick={() => onSaveExhibiton(Constants.exhibitionStatus.DELETED)}
                            />
                        </span>
                        <span className="block text-6xl  mb-1  p-2 w-6  pr-5">
                            <InputText value={props?.exhibitionName} onChange={(e) => props?.setExhibitionName(e.target.value)}
                                className="inputtext_raunded p-inputtext w-12"
                                placeholder={t('global_exhibition_name')}
                                maxLength={40} />
                        </span>
                        <span className="block text-1xl  mb-1 p-2 w-6 pr-5" >
                            <Calendar value={dates} onChange={(e) => onDateSelect(e)} selectionMode="range"
                                className='w-12' dateFormat="dd/mm/yy"
                                showIcon icon={() => <i className="fas fa-calendar-plus" />} iconPos='left'
                                minDate={new Date()}
                                placeholder={t('global_exhibition_selectdate')} readOnlyInput hideOnRangeSelection />

                        </span>
                        <span className="block text-2xl  mb-1  p-2 w-12 pr-5">

                            <div className="col-12 md:col-12 p-0">
                                <InputTextarea value={props?.exhibitionDescr} onChange={(e) => props?.setExhibitionDescr(e.target.value)}
                                    className="inputtext_raunded p-inputtext  w-12 p-4"
                                    placeholder={t('global_exhibition_descr')}
                                    rows={10} cols={75} autoResize maxLength={500} />
                            </div>
                            <div className=" flex  pr-3 pb-3 w-12 justify-content-end font-600-regular">
                                {props?.exhibitionDescr?.length + " / 500"}
                            </div>
                        </span>


                        <div className='fixed-bottom  mb-5 ml-5 '>
                            <Button icon="fas fa-angle-down" className="p-button-rounded p-button-text mr-2 mb-2 text-align-center" label={t('select_art')}
                                onClick={() => {
                                    console.log("Eser Seçimi Click");
                                    props.onSelectArtPage();
                                }}
                            />
                        </div>
                    </div>
                }
                {!props?.isEditable &&
                    <div className="flex flex-column justify-content-center  align-items-start w-6 h-12" >
                        <div className='flex flex-row justify-content-start  align-items-center  w-12 mb-3'
                            style={{}}
                        >
                            <div 
                            className='pointer'
                            style={{
                                flexDirection: 'row',
                                display: 'flex',
                                background: 'rgba(0,0,0, 0.65)',
                                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                                borderRadius: 20,
                                backdropFilter: 'blur(10px)',
                                padding: 2,
                                paddingRight: 5,
                                paddingLeft: 5,
                                alignItems: 'center',
                               

                            }}
                            onClick={() => {
                                
                                    console.log("onClick", props)
                                    navigate("/profile/" + props?.userId + "/" + props?.userType );
                                
                            }}
                            >

                                <div style={{
                                    width: 25, height: 25, borderRadius: 30,
                                    backgroundImage: `url(${FileService.inquireFilePath(props?.profileImage)})`,
                                }}
                                />
                                <div className='font-white p-2' style={{ paddingLeft: 5, color: 'black', fontSize: 14, fontWeight: '400', wordWrap: 'break-word', textAlign: 'center' }}>  {props.firstName + " " + props.lastName}</div>
                            </div>
                            <Button icon="fa-regular fa-heart" className={props?.favoriteId ? "p-button-rounded ml-2" : "p-button-rounded p-button-gray ml-2"}
                                onClick={() => {
                                    if (props.favoriteId)
                                        props.onRemoveFavorite(props.favoriteId);
                                    else
                                        props.onAddFavorite(Constants.entityNames.exhibition)
                                }}
                            />
                        </div>
                        <span className="block text-6xl  mb-1  p-2">
                            {props?.exhibitionName}
                        </span>
                        <span className="block text-1xl  mb-1 p-2">
                            {utils.formatDate(props?.startDate) + '-' + utils.formatDate(props?.endDate)}
                        </span>
                        <span className="block text-2xl  mb-1  p-2">
                            {props?.exhibitionDescr}
                        </span>

                        <div className='fixed-bottom  mb-5 ml-0 '>
                            <Button icon="fas fa-angle-down" className="p-button-rounded p-button-text mr-2 mb-2 text-align-center" label={t('start_art')}
                                onClick={() => {
                                    console.log("Eser Seçimi Click");
                                    props.onSelectArtPage();
                                }}
                            />
                        </div>
                        {props.isExhibitOwner && props.status == 2 &&

                            <span className="block   mb-1  p-2 mt-8" icon="fas fa-circle-info">
                                <i className="fas fa-circle-info pr-2" style={{ color: 'var(--primary-color)' }}></i>
                                <i>{t('exhibit_send_approve_descr')}</i>
                            </span>
                        }
                    </div>
                }

                <div className="flex flex-column align-items-center justify-content-center  w-6"
                    style={{
                        backgroundColor: "#F6F6F6",
                        backgroundImage: `url(${props.headerImageData?.upploadFlag == false ? FileService.inquireFilePath(props.headerImageData?.file) : props.headerImageData?.file})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                    }}
                >
                    {props.isEditable &&
                        <FileUpload mode="basic" auto name="demo[]"
                            accept="image/*" maxFileSize={10000000}
                            label="Kapak Fotoğrafı Ekle"
                            onSelect={props.onFileSelect}
                            chooseOptions={chooseOptions}
                            onUpload={() => console.log("uploaded image")}
                            iconOnly={true}

                        />

                        /*  <Button icon="fas fa-cloud-arrow-up" className={"p-button-rounded p-button-header"} label='Kapak Fotografı Ekle'
                              onClick={() => {
                                  props.setAddImageVisible(true)
                                  props.setImageFileType(Constants.fileTypes.profile_photo);
                              }
                              }
                          />*/



                    }
                </div>


            </div>
        );
    };

    return (
        <div className='surface-profile-header'>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <div className='root-exhibiton' style={{}}>
                <div className="grid grid-nogutter surface-profile-main text-800"


                >
                    <ExhibitonTopbar {...props} />
                    <div className="surface-profile" >

                        {RenderContent()}
                    </div>

                </div>
            </div>
        </div>
    );
}